import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThumbnailList } from '../ThumbnailList';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';
import { Link } from 'react-router-dom';
import { Icons } from '@ohif/ui-next';
import moment from 'moment';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  isActive,
  onClick,
  isExpanded,
  displaySets,
  activeDisplaySetInstanceUIDs,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  viewPreset = 'thumbnails',
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
}: withAppTypes) => {
  const query = new URLSearchParams();
  query.append('StudyInstanceUID', String(StudyInstanceUID));

  const formattedDate = moment(date, 'DD-MMM-YYYY')
    .locale('es')
    .format('DD-MMM-YYYY')
    .toUpperCase();

  const RISEnabled = window.config?.risEnable;

  const redirect = `medisapp://radoffice/frameset/main?href=/RadOffice/Office/Resume/Visit/ResultsFromPACSWorkstation.asp?StudyInstanceUID=${StudyInstanceUID}&DirectAccess=True`;

  return (
    <Accordion
      type="single"
      collapsible
      onClick={onClick}
      onKeyDown={() => { }}
      className="flex-shrink-0"
      role="button"
      tabIndex={0}
      defaultValue={isActive ? 'study-item' : undefined}
    >
      <AccordionItem value="study-item">
        <AccordionTrigger
          className={classnames('hover:bg-accent bg-popover group w-full rounded')}
          onClick={e => e.stopPropagation()}
        >
          <div className="flex h-[40px] w-full flex-row overflow-hidden">
            <div className="flex w-full flex-row items-center justify-between">
              <div className="flex min-w-0 flex-col items-start text-[13px]">
                <div className="flex items-center gap-1">
                  <Tooltip>
                    <TooltipTrigger
                      asChild
                      className="w-full"
                    >
                      <div className="h-[18px] w-full max-w-[160px] overflow-hidden truncate whitespace-nowrap text-left text-white">
                        {formattedDate}
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>{formattedDate}</TooltipContent>
                  </Tooltip>
                </div>
                <Tooltip>
                  <TooltipTrigger
                    className="w-full"
                    asChild
                  >
                    <div className="text-muted-foreground h-[18px] w-full overflow-hidden truncate whitespace-nowrap text-left">
                      {description}
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>{description}</TooltipContent>
                </Tooltip>
              </div>
              {RISEnabled ? (
                <Link
                  to={redirect}
                  replace={RISEnabled ? true : false}
                  className="flex h-full !min-w-[20px] cursor-pointer"
                  onClick={e => e.stopPropagation()}
                >
                  <Icons.RadOffice className="!h-[19px] !w-[19px] hover:drop-shadow-[0_2px_5px_#01f0f2]" />
                </Link>
              ) : null}
              <div className="text-muted-foreground flex flex-col items-end text-[12px]">
                <div className="max-w-[130px] overflow-hidden text-ellipsis">{modalities}</div>
                <div>{numInstances}</div>
              </div>
              {StudyMenuItems && (
                <div className="ml-2 flex items-center">
                  <StudyMenuItems StudyInstanceUID={StudyInstanceUID} />
                </div>
              )}
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent
          onClick={event => {
            event.stopPropagation();
          }}
        >
          {isExpanded && displaySets && (
            <ThumbnailList
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              ThumbnailMenuItems={ThumbnailMenuItems}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
};

export { StudyItem };
